<div class="rail-content">

  <!-- Everything above the action footer. The footer is sticky, and sticky does
       not reserve space at its shifted position, so this wrapper pads the
       footer's height out of the way — otherwise the last control (the Refine
       group's Income Type select) renders underneath it. -->
  <div class="rail-scroll">

  <!-- Scope (All / My Shelf). Removed entirely when the IA shelf
       permission is 'shelf' — see showShelfScope(). The page header used to
       carry a second copy of this switch; this is now the only one. -->
  @if (showShelfScope()) {
    <div class="rail-scope-grp">
      <div class="scope-label">Scope</div>
      <div class="scope-row">
        <span class="scope-row-label">Products</span>
        <div class="shelf-switch"
             [class.shelf-switch-disabled]="shelfState() === 'disabled'"
             [attr.title]="shelfState() === 'disabled' ? 'Select a user via Admin to enable' : 'Toggle between all products and your shelf'">
          <span class="shelf-sw-opt"
                [class.shelf-sw-active]="shelfState() === 'off'"
                (click)="onShelfClick()">All</span>
          <span class="shelf-sw-opt"
                [class.shelf-sw-active]="shelfState() === 'on'"
                (click)="onShelfClick()">My Shelf</span>
        </div>
      </div>
    </div>
  }

  <!-- ═══ Client Scenario ═══ -->
  <div class="rail-scn">
    <div class="scn-hdr">
      <span class="scn-label">Client Scenario</span>
      @if (savedSearches().length) {
        <select class="saved-sel" [value]="activeSearchName()"
                (change)="onSavedSearchChange($any($event.target).value)">
          <option value="">My Searches</option>
          @for (s of savedSearches(); track s.name) {
            <option [value]="s.name">{{ s.name }}</option>
          }
        </select>
      }
    </div>

    <div class="fg-row">
      <div class="fg" [class.has-error]="ageError()">
        <label>Client Age</label>
        <input type="text" inputmode="numeric" maxlength="3" class="f-in mono"
               [value]="clientAge()"
               (keydown)="onWholeNumberKeydown($event)"
               (input)="onWholeNumberInput($event, clientAge, 100, ageError)">
      </div>
      <div class="fg">
        <label>Gender</label>
        <select class="f-sel" [ngModel]="gender()" (ngModelChange)="gender.set($event)">
          <option value="M">Male</option>
          <option value="F">Female</option>
          <option value="">All</option>
        </select>
      </div>
    </div>
    @if (ageError()) { <span class="field-error">{{ ageError() }}</span> }

    <div class="fg">
      <label>Ownership</label>
      <div class="seg">
        <button type="button" [class.on]="ownership() === 'Single'" (click)="ownership.set('Single')">Single</button>
        <button type="button" [class.on]="ownership() === 'Joint'" (click)="switchToJoint()">Joint</button>
      </div>
    </div>

    <div class="fg" [class.is-off]="ownership() === 'Single'" [class.has-error]="spouseAgeError()">
      <label>Spouse Age</label>
      <input type="text" inputmode="numeric" maxlength="3" class="f-in mono"
             [disabled]="ownership() === 'Single'"
             [value]="spouseAge()"
             (keydown)="onWholeNumberKeydown($event)"
             (input)="onWholeNumberInput($event, spouseAge, 100, spouseAgeError)">
      @if (spouseAgeError()) { <span class="field-error">{{ spouseAgeError() }}</span> }
    </div>

    <div class="rail-div"></div>

    <div class="fg">
      <label>Amount Type</label>
      <div class="seg">
        <button type="button" [class.on]="amountType() === 'contribution'" (click)="amountType.set('contribution')">Contribution</button>
        <button type="button" [class.on]="amountType() === 'income'" (click)="amountType.set('income')">Income</button>
      </div>
    </div>

    <div class="fg" [class.has-error]="contributionError()">
      <label>{{ amountType() === 'contribution' ? 'Contribution' : 'Desired Income' }}</label>
      <div class="f-pre">
        <span class="sig">$</span>
        <input type="text" inputmode="numeric" class="f-in mono"
               [value]="contributionDisplay()"
               (input)="onContributionInput($event)"
               (blur)="onContributionBlur()">
      </div>
      @if (contributionError()) { <span class="field-error">{{ contributionError() }}</span> }
    </div>

    <div class="fg-row">
      <div class="fg" [class.has-error]="deferralError()">
        <label>Deferral</label>
        <div class="f-suf">
          <input type="text" inputmode="numeric" maxlength="2" class="f-in mono"
                 [value]="deferralYear()"
                 (keydown)="onWholeNumberKeydown($event)"
                 (input)="onWholeNumberInput($event, deferralYear, 40, deferralError)">
          <span class="sig">yrs</span>
        </div>
      </div>
      <div class="fg">
        <label>State</label>
        <select class="f-sel" [ngModel]="stateCode()" (ngModelChange)="stateCode.set($event)">
          @for (s of states(); track s.stateCode) {
            <option [value]="s.stateCode">{{ s.stateCode }}</option>
          }
        </select>
      </div>
    </div>
    @if (deferralError()) { <span class="field-error">{{ deferralError() }}</span> }

    <div class="fg">
      <label>Payment</label>
      <select class="f-sel" [ngModel]="paymentType()" (ngModelChange)="paymentType.set($event)">
        <option value="Single">Single</option>
        <option value="Flexible">Flexible</option>
        <option value="SingleWithAdditional">Single + Add'l</option>
      </select>
    </div>
  </div>

  <!-- ═══ Refine — narrows the rows already returned, no re-query ═══ -->
  @if (hasSearched()) {
    <div class="rail-refine">
      <div class="scn-hdr"><span class="scn-label">Refine</span></div>

      <div class="rail-search-wrap">
        <svg class="rail-search-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/>
        </svg>
        <input class="rail-search" type="text" maxlength="50" placeholder="Company, rider, or product…"
               [value]="searchDisplayText()" (input)="onSearchInput($event)"
               aria-label="Search results" />
        @if (searchDisplayText()) {
          <button type="button" class="rail-find-clear" (click)="onSearchClear()" aria-label="Clear search">×</button>
        }
      </div>

      <div class="fg">
        <label>A.M. Best</label>
        <div class="ms-wrap">
          <button type="button" class="ms-trigger" (click)="amBestOpen.update(v => !v)">
            <!-- Names the picks, as the header chip does ("A++, A+ +4"), rather
                 than a bare count; ALL when none. -->
            <span class="ms-value" [title]="amBestFilter().join(', ')">{{ amBestSummary() }}</span>
            <span class="ms-caret" [class.ms-caret-open]="amBestOpen()" aria-hidden="true">
              <svg viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l4 4 4-4"/></svg>
            </span>
          </button>
          @if (amBestOpen()) {
            <div class="ms-backdrop" (click)="amBestOpen.set(false)"></div>
            <div class="ms-panel" (click)="$event.stopPropagation()">
              @for (b of amBestOptions(); track b.rating ?? b.bestid) {
                <label class="ms-item">
                  <input type="checkbox"
                         [checked]="amBestFilter().includes(b.rating ?? b.bestid ?? '')"
                         (change)="toggleAmBest(b.rating ?? b.bestid ?? '')" />
                  <span>{{ b.rating ?? b.bestid }}</span>
                </label>
              }
            </div>
          }
        </div>
      </div>

      <div class="fg">
        <label>Surr Year</label>
        <select class="f-sel" [ngModel]="surrYearFilter() ?? ''"
                (ngModelChange)="setSurrFilter(+$event || null)">
          <option value="">ALL</option>
          @for (s of surrYearOptions(); track s.surryr) {
            <option [value]="s.surryr">≤ {{ s.surryr }} yr</option>
          }
        </select>
      </div>

      <div class="fg">
        <label>Income Type</label>
        <!-- The rider-type feed carries its own "ALL" entry, which duplicated the
             unfiltered option. Only the '' option is offered; a persisted 'ALL'
             (already treated as unfiltered) displays as it. -->
        <select class="f-sel" [ngModel]="benefitBaseFilter() === 'ALL' ? '' : benefitBaseFilter()"
                (ngModelChange)="benefitBaseFilter.set($event)">
          <option value="">ALL</option>
          @for (t of riderTypeOptions(); track t.id) {
            @if (t.value.toUpperCase() !== 'ALL') {
              <option [value]="t.value">{{ t.value }}</option>
            }
          }
        </select>
      </div>
    </div>
  }

  </div>

  <!-- ═══ Actions — sticky, so Calculate never scrolls off ═══ -->
  <div class="rail-foot">
    @if (showSaveSearch()) {
      <div class="foot-row">
        <input type="text" class="save-name" placeholder="Search name…"
               [value]="saveSearchName()" (input)="saveSearchName.set($any($event.target).value)"
               (keyup.enter)="saveSearch()">
        <button type="button" class="btn btn-primary" (click)="saveSearch()">Save</button>
        <button type="button" class="btn btn-ghost" (click)="showSaveSearch.set(false)">✕</button>
      </div>
    } @else {
      <div class="foot-row">
        <button type="button" class="btn btn-ghost fill" (click)="onReset()"
                [disabled]="!canReset()"
                [title]="canReset() ? 'Reset all inputs to defaults' : 'Nothing to reset'">Reset</button>
        <button type="button" class="btn btn-ghost fill" (click)="onSaveDefaults()"
                title="Save current inputs as defaults">Set Default</button>
      </div>
      <div class="foot-row">
        <button type="button" class="btn btn-ghost fill" (click)="showSaveSearch.set(true)">Save Search</button>
      </div>
    }
    <!-- Results now refresh on their own as the scenario changes; this stays as
         an explicit re-run (and the affordance users look for). -->
    <!-- <button type="button" class="btn btn-primary btn-calc" (click)="onCalculate()" [disabled]="loading()"
            title="Recalculate now">
      @if (loading()) { Calculating… } @else { ▸ Calculate }
    </button> -->
    <div class="foot-hint">Updates automatically · all calculations are server-side</div>
  </div>

</div>
